import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { SITE } from "../../lib/site";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Hologram Stickers", to: "/hologram-stickers" },
  { label: "Security Labels", to: "/security-labels" },
  { label: "Products", to: "/products" },
  { label: "Industries", to: "/industries" },
  { label: "Solutions", to: "/solutions" },
  { label: "About Us", to: "/about-us" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => { setOpen(false); }, [loc.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 border-b ${scrolled ? "bg-black/70 backdrop-blur-2xl border-white/10" : "bg-black/30 backdrop-blur-xl border-transparent"}`}
    >
      <div className="px-6 md:px-10 lg:px-16 h-16 md:h-20 flex items-center justify-between gap-4">
        <Link to="/" data-testid="logo-link" className="flex items-center shrink-0">
          <img src="/logo.png?v=2" alt="NanoMax Holo Solutions LLC logo" className="h-10 md:h-12 w-auto drop-shadow-[0_0_12px_rgba(0,240,255,0.15)]" />
        </Link>

        <nav className="hidden xl:flex items-center gap-6" aria-label="Primary">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`font-mono2 text-[11px] uppercase tracking-[0.12em] transition-colors duration-300 hover:text-holo-cyan ${loc.pathname === n.to ? "text-holo-cyan" : "text-[#8A8A9B]"}`}>
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3 shrink-0">
          <a href={SITE.whatsapp} target="_blank" rel="noreferrer" data-testid="header-whatsapp" className="btn-ghost px-4 py-2 text-[11px] flex items-center gap-2">
            <MessageCircle size={14} /> WhatsApp
          </a>
          <Link to="/contact" data-testid="header-quote" className="btn-primary px-5 py-2.5 text-[11px]">Get a Free Quote</Link>
        </div>

        <button className="xl:hidden text-white p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="xl:hidden bg-black/95 backdrop-blur-2xl border-t border-white/10 max-h-[80vh] overflow-y-auto">
          <nav className="flex flex-col p-6 gap-1" aria-label="Mobile">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="font-mono2 text-sm uppercase tracking-[0.1em] py-3 border-b border-white/5 text-[#C9C9D4]">
                {n.label}
              </Link>
            ))}
            <Link to="/contact" className="btn-primary text-center px-5 py-3 mt-4 text-xs">Get a Free Quote</Link>
          </nav>
        </div>
      )}
    </header>
  );
}
